
import { mapState } from 'vuex';
import HorizontalScroll from './components/HorizontalScroll.vue';

export default {
  i18nComponentKey: 'WidgetCategoryReviewsHorizontalScroll.WidgetCategoryReviewsHorizontalScrollPc',
  name: 'WidgetCategoryReviewsHorizontalScrollPc',
  components: { HorizontalScroll },
  computed: {
    ...mapState('widget', ['widget'])
  }
};
